import { translate } from '@portal/services/i18n';

export enum PayableStatus {
  PROCESSING = 1,
  EXECUTED = 2,
  ERROR = 3,
  ERROR_CORE_BANK = 4,
  WAITING_APPROVAL = 5,
  PORTABILITY_EXECUTED = 6,
  REPROVED = 7,
  PAYMENT_TYPE_NOT_FOUND = 8,
  ERROR_INVALID_INPUT = 9,
  ERROR_ACCOUNT_NOT_FOUND = 10,
  ERROR_EMPLOYEE_NOT_BELONG_THIS_COMPANY = 11,
  ERROR_EMPLOYEE_NOT_CREATED = 12,
  SCHEDULED = 13,
}

export const PayableStatusArray = [
  {
    value: PayableStatus.PROCESSING,
    name: translate(
      'PAGES.EMPLOYEES.EMPLOYEES_PAYMENT.PAYMENT_DETAILS.PAYABLE_STATUS.PROCESSING'
    ),
  },
  {
    value: PayableStatus.EXECUTED,
    name: translate(
      'PAGES.EMPLOYEES.EMPLOYEES_PAYMENT.PAYMENT_DETAILS.PAYABLE_STATUS.EXECUTED'
    ),
  },
  {
    value: PayableStatus.ERROR,
    name: translate(
      'PAGES.EMPLOYEES.EMPLOYEES_PAYMENT.PAYMENT_DETAILS.PAYABLE_STATUS.ERROR'
    ),
  },
  {
    value: PayableStatus.ERROR_CORE_BANK,
    name: translate(
      'PAGES.EMPLOYEES.EMPLOYEES_PAYMENT.PAYMENT_DETAILS.PAYABLE_STATUS.ERROR_CORE_BANK'
    ),
  },
  {
    value: PayableStatus.WAITING_APPROVAL,
    name: translate(
      'PAGES.EMPLOYEES.EMPLOYEES_PAYMENT.PAYMENT_DETAILS.PAYABLE_STATUS.WAITING_APPROVAL'
    ),
  },
  {
    value: PayableStatus.PORTABILITY_EXECUTED,
    name: translate(
      'PAGES.EMPLOYEES.EMPLOYEES_PAYMENT.PAYMENT_DETAILS.PAYABLE_STATUS.PORTABILITY_EXECUTED'
    ),
  },
  {
    value: PayableStatus.REPROVED,
    name: translate(
      'PAGES.EMPLOYEES.EMPLOYEES_PAYMENT.PAYMENT_DETAILS.PAYABLE_STATUS.REPROVED'
    ),
  },
  {
    value: PayableStatus.PAYMENT_TYPE_NOT_FOUND,
    name: translate(
      'PAGES.EMPLOYEES.EMPLOYEES_PAYMENT.PAYMENT_DETAILS.PAYABLE_STATUS.PAYMENT_TYPE_NOT_FOUND'
    ),
  },
  {
    value: PayableStatus.ERROR_INVALID_INPUT,
    name: translate(
      'PAGES.EMPLOYEES.EMPLOYEES_PAYMENT.PAYMENT_DETAILS.PAYABLE_STATUS.ERROR_INVALID_INPUT'
    ),
  },
  {
    value: PayableStatus.ERROR_ACCOUNT_NOT_FOUND,
    name: translate(
      'PAGES.EMPLOYEES.EMPLOYEES_PAYMENT.PAYMENT_DETAILS.PAYABLE_STATUS.ERROR_ACCOUNT_NOT_FOUND'
    ),
  },
  {
    value: PayableStatus.ERROR_EMPLOYEE_NOT_BELONG_THIS_COMPANY,
    name: translate(
      'PAGES.EMPLOYEES.EMPLOYEES_PAYMENT.PAYMENT_DETAILS.PAYABLE_STATUS.ERROR_EMPLOYEE_NOT_BELONG_THIS_COMPANY'
    ),
  },
  {
    value: PayableStatus.ERROR_EMPLOYEE_NOT_CREATED,
    name: translate(
      'PAGES.EMPLOYEES.EMPLOYEES_PAYMENT.PAYMENT_DETAILS.PAYABLE_STATUS.ERROR_EMPLOYEE_NOT_CREATED'
    ),
  },
  {
    value: PayableStatus.SCHEDULED,
    name: translate(
      'PAGES.EMPLOYEES.EMPLOYEES_PAYMENT.PAYMENT_DETAILS.PAYABLE_STATUS.SCHEDULED'
    ),
  },
];

export const getPayableStatus = (value: number) => {
  return PayableStatusArray.find((payment) => payment.value === value)?.name;
};
